import Text from "./Text";
import Box from "./Box";
import Header from "./Header";
import Hero from "./Hero";
import Info from "./Info";
import Prices from "./Prices";
import Image from "./Image";
import Button from "./Button";
import Video from "./Video";
import Price from "./Price";
import ScrollTape from "./ScrollTape";
import Html from "./Html";
import PriceBox from "./PriceBox";
import ListItem from "./ListItem";
import FAQ from "./FAQ";
import Form from "./Form";

import HeroRounded from "./Heros/HeroRounded";
import ButtonLinear from "./Buttons/ButtonLinear";
import MembersAvatars from "./SocialProof/MembersAvatars";
import StarsBox from './SocialProof/StarsBox'
import Row from "./Display/Row";
import MediaColumnsScroll from "./Galery/MediaColumnsScroll/index";
import MediaFloating from "./Galery/MediaFloading/index";
import IconWithText from "./Labels/IconWithText";
import { useEffect, useState } from "react";
import OptionsControl from "./Buttons/OptionsControl";
import Carousel from "./Carousel";
import RawWideWithIcon from "./Labels/RawWideWithIcon";
import WhatsAppButton from "./Buttons/WhatsApp";


const AvailableComponents = {
  TEXT: (props) => <Wrapper {...props} children={Text} />,
  BOX: (props) => <Wrapper {...props} children={Box} />,
  HEADER: (props) => <Wrapper {...props} children={Header} />,
  INFO: (props) => <Wrapper {...props} children={Info} />,
  PRICES: (props) => <Wrapper {...props} children={Prices} />,
  IMAGE: (props) => <Wrapper {...props} children={Image} />,
  VIDEO: (props) => <Wrapper {...props} children={Video} />,
  PRICE: (props) => <Wrapper {...props} children={Price} />,
  SCROLL_TAPE: (props) => <Wrapper {...props} children={ScrollTape} />,
  HTML: (props) => <Wrapper {...props} children={Html} />,
  PRICE_BOX: (props) => <Wrapper {...props} children={PriceBox} />,
  LIST_ITEM: (props) => <Wrapper {...props} children={ListItem} />,
  FAQ: (props) => <Wrapper {...props} children={FAQ} />,

  HERO: (props) => <Wrapper {...props} children={Hero} />,
  ROUNDEDHERO: (props) => <Wrapper {...props} children={HeroRounded} />,

  FORM: (props) => <Wrapper {...props} children={Form} />,

  BUTTON: (props) => <Wrapper {...props} children={Button} />,
  BUTTONLINEAR: (props) => <Wrapper {...props} children={ButtonLinear} />,
  WHATSAPP_BUTTON: (props) => <Wrapper {...props} children={WhatsAppButton} />,


  CONTROL: (props) => <Wrapper {...props} children={OptionsControl} />,

  MEMBERSAVATARS: (props) => <Wrapper {...props} children={MembersAvatars} />,

  STARSBOX: (props) => <Wrapper {...props} children={StarsBox} />,

  ROW: (props) => <Wrapper {...props} children={Row} />,

  MEDIA_COLUMNS_SCROLL: (props) => <Wrapper {...props} children={MediaColumnsScroll} />,
  GALERY_FLOATING: (props) => <Wrapper {...props} children={MediaFloating} />,

  LABEL_ICON_TEXT: (props) => <Wrapper {...props} children={IconWithText} />,

  CAROUSEL: (props) => <Wrapper {...props} children={Carousel} />,

  RAW_WIDE_ICON_WITH_TEXT: (props) => <Wrapper {...props} children={RawWideWithIcon} />
};

export { AvailableComponents };


function Wrapper({ children, ...props }) {
  const Comp = children

  const control = props?.config?.control

  const [display, setDisplay] = useState(true)

  useEffect(() => {
    if (control?.id) {
      const evt = 'control.' + control.id
      window.addEventListener(evt, controlHandler)
      return () => window.removeEventListener(evt, controlHandler)
    }
  }, [])

  function controlHandler({ detail }) {
    console.log('Control listener change')
    console.log(detail)
    setDisplay(detail.value === control.value)
  }

  if (!display) return null

  return <Comp {...props} />
}